import { pt, en, es } from "vuetify/locale";
import ptBR from "./locales/pt-BR";
import enUS from "./locales/en-US";
import esES from "./locales/es-ES";

// Função que mescla locales do Vuetify com nossos locales personalizados
function mergeLocales(vuetifyLocale: any, customLocale: any) {
	const dataTableLocales = customLocale.table || {};
	const generalLocales = customLocale.general || {};

	// Determine o texto para "Todos" baseado no idioma
	const allItemsText =
		customLocale.locale === "pt-BR"
			? "Todos"
			: customLocale.locale === "es-ES"
			? "Todos"
			: "All";

	return {
		...vuetifyLocale,
		dataTable: {
			...(vuetifyLocale.dataTable || {}),
			noDataText:
				dataTableLocales.noDataText || vuetifyLocale.dataTable?.noDataText,
			itemsPerPageText:
				dataTableLocales.rowsPerPageText ||
				vuetifyLocale.dataTable?.itemsPerPageText,
			pageText: dataTableLocales.pageText || vuetifyLocale.dataTable?.pageText,
			itemsPerPageAll: allItemsText,
			loadingText:
				dataTableLocales.loading ||
				generalLocales.loading ||
				vuetifyLocale.dataTable?.loadingText,
			sortBy: dataTableLocales.sortBy || vuetifyLocale.dataTable?.sortBy,
			footer: {
				itemsPerPageText:
					dataTableLocales.rowsPerPageText ||
					vuetifyLocale.dataTable?.itemsPerPageText,
				pageText:
					dataTableLocales.pageText || vuetifyLocale.dataTable?.pageText,
				itemsPerPageAll: allItemsText,
			},
		},
	};
}

// Mesclando nossos locales com os do Vuetify
export const customLocales = {
	"pt-BR": mergeLocales(pt, ptBR),
	"en-US": mergeLocales(en, enUS),
	"es-ES": mergeLocales(es, esES),
};
